import api from './api';
import types from './mutation-types';

export default {
	postSearchSelectList_({ commit }) {
		return api
			.postSearchSelectList()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'tgrpYnList',
						value: data.body.YN || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'ceqTypeList',
						value: data.body.CEQ_TYPE || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'ctypeList',
						value: data.body.CTYPE || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'causCdListPop',
						value: data.body.CAUS_CD || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'occuRegnListPop',
						value: data.body.OCCU_REGN || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'prcsStepList',
						value: data.body.PRCS_STEP_01 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'prcsRsltList',
						value: data.body.PRCS_RSLT_01 || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'clmDdList',
						value: data.body.PWA_DD || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateApcnInit_({ commit }) {
		commit(types.STATE_APCN_INIT);
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getClamRepayList_({ commit, state }) {
		const { searchParams, pagingInfo } = state;

		return api
			.getClamRepayList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'clamRepayList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	async getClamNoPopList_({ commit, state }, clamNoParam) {
		// 클레임 신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getClamNoPopList(clamNoParam.clmNo)
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터 클레임 조회 값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'clamMstPopUp',
						value: data?.body.resultVo || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'clamMstSwapPartsList',
						value: data?.body.resultList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});

					/*컴포넌트 READONLY 처리 */
					commit(types.APCN_INFO, {
						key: 'readOnlyAuth',
						value: data.body.resultVo.prcsStepCl == '20' || data.body.resultVo.prcsStepCl == '30' ? true : false
					});

					//콤포넌트 커밋
					commit(types.APCN_INFO, {
						key: 'readOnlyAuth1',
						value: data.body.resultVo.prcsStepCl == '20' || data.body.resultVo.prcsStepCl == '30' ? true : false
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}, //실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload({ params });
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	},
	saveClamMstPopup_({ commit }, { formData }) {
		/*fromData 찍어보기*/
		return api
			.saveClamMstPopup({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	delApcnSwapInfoList_({ commit }, param) {
		return api
			.delApcnSwapInfoList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnSwapPartsList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	saveStateAppr_({ commit, state }, payload) {
		//param,
		return api
			.saveStateAppr(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPopupSearchParam_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	}
};
